import { render, staticRenderFns } from "./selcate.vue?vue&type=template&id=7ec08f18&"
import script from "./selcate.vue?vue&type=script&lang=js&"
export * from "./selcate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports